import { getSmartConfig, setSmartCOnfig, delSmartIP } from '@/services/config'

const store = {
  namespaced: true,
  state: {
    baseConfig: {}, // 表单配置/职能拦截基础信息
    loading: false,
    isSeting: false,
    filterSort: []
  },
  mutations: {
    SET_BASE_CONFIG (state, data) {
      state.baseConfig = Object.assign({}, data)
    },
    SET_LOAD (state, load) {
      state.loading = load
    },
    SET_BASE_CONFIG_KEY (state, params) {
      const { key: field, value } = params
      state.baseConfig = Object.assign(state.baseConfig, { [field]: value })
    },
    SET_IS_SETTING (state, type) {
      state.isSeting = type
    },
    SET_BASE_CONFIG_INDEX (state, params) {
      const { key, index } = params
      state.baseConfig[key].splice(index, 1)
    },
    SET_FILTER_SORT (state, data) {
      state.filterSort = data
    }
  },
  actions: {
    // 获取配置
    async getFormConfigInfo ({ commit }) {
      commit('SET_LOAD', true)
      const chain = await getSmartConfig()
        .onSuccess(res => {
          res = Object.assign(res, { interceptContent: res.intercept_dict.join('\n') })
          commit('SET_BASE_CONFIG', res)
          commit('SET_FILTER_SORT', res.default)
        })
        .onNetComplete(() => {
          commit('SET_LOAD', false)
        })
        .config({ tip: false })
        .fetch()
      return chain
    },
    // 设置配置
    async setFormConfig ({ commit, dispatch }, params) {
      commit('SET_IS_SETTING', true)
      // console.log(params)
      const chain = await setSmartCOnfig()
        .params(params)
        .onSuccess(res => {
          for (let key in params) {
            // console.log({ 'key': key, 'value': params[key] })
            if (['black_ip_list', 'ids'].includes(key)) {
              dispatch('getFormConfigInfo')
            } else {
              commit('SET_BASE_CONFIG_KEY', { 'key': key, 'value': params[key] })
            }
          }
        })
        .onNetComplete(() => {
          commit('SET_IS_SETTING', false)
        })
        .config({ tip: true })
        .fetch()
      return chain
    },
    // 删除黑名单中的单个IP
    async delIP ({ commit }, params) {
      const chain = await delSmartIP()
        .params(params)
        .onSuccess(res => {
          const { index } = params
          commit('SET_BASE_CONFIG_INDEX', { key: 'black_ip_list', index })
        })
        .config({ tip: false })
        .fetch()
      return chain
    }
  }
}

export default store
